import React, { useContext, useMemo, useState } from 'react';
import useWindowWidth from '../../../../hooks/useWindowWidth';

// Types
interface SiteKitContextValue {
  isMobileOrTablet: boolean;
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

// Constants
const defaultValue: SiteKitContextValue = {
  isMobileOrTablet: false,
  sidebarOpen: true,
  setSidebarOpen: () => undefined,
};

// Contexts
const SiteKitContext = React.createContext(defaultValue);

// Exports
interface SiteKitProviderProps {
  children: React.ReactNode;
}
const SiteKitProvider = ({ children }: SiteKitProviderProps) => {
  const { isMobile, isTabletPortrait } = useWindowWidth();
  const isMobileOrTablet = isMobile || isTabletPortrait;
  const [sidebarOpen, setSidebarOpen] = useState(!isMobileOrTablet);
  const contextValue = useMemo(() => ({ isMobileOrTablet, sidebarOpen, setSidebarOpen }), [
    isMobileOrTablet,
    sidebarOpen,
  ]);

  return <SiteKitContext.Provider value={contextValue}>{children}</SiteKitContext.Provider>;
};
const useSiteKit = () => useContext(SiteKitContext);
export { SiteKitContextValue, SiteKitProvider, SiteKitProviderProps, useSiteKit };
